module.exports = __webpack_public_path__ + "assets/img/fullscreen.9ce971c6.svg";